<template>
  <v-dialog v-model="dialog" width="900">
    <template v-slot:activator="{ on }">
      <v-card max-width="180" class="text-center people-card" v-on="on">
        <img :src="person.photo" :alt="person.name" class="people-image" />
        <div>{{ person.name }}</div>
        <div v-if="person.workingWith" class="working-with-text">
          working with {{ person.workingWith }}
        </div>
      </v-card>
    </template>

    <v-card class="people-dialog-card link">
      <v-row>
        <v-col cols="12" lg="3">
          <v-row no-gutters>
            <v-col class="text-center">
              <img
                :src="person.photo"
                :alt="person.name"
                class="people-dialog-image"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col nogu class="text-center">
              <v-btn
                v-if="person.website"
                text
                small
                color="rgb(153, 27, 30)"
                target="_blank"
                :href="person.website"
              >
                <v-icon left dense>mdi-home</v-icon> Website
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="text-center">
              <v-btn
                v-if="person.email"
                text
                small
                color="rgb(153, 27, 30)"
                target="_blank"
                :href="'mailto:' + person.email"
              >
                <v-icon left dense>mdi-email</v-icon> Contact
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" lg="9">
          <div style="display: flex; align-items: center;">
            <h1 class="person-modal-name">{{ person.name }}</h1>
            <v-btn
                v-if="person.audio"
                text
                color="rgb(153, 27, 30)"
                target="_blank"
                @click="readName"
                style="margin-left:10px"
            >
              <v-icon left dense>mdi-bullhorn</v-icon> How to pronounce my name
            </v-btn>
          </div>
          <h4 class="person-modal-title">{{ title }}</h4>
          <p v-html="$sanitize(person.description)"></p>

          <div v-if="person.awards">
            <h3>Awards:</h3>
            <ul>
              <v-row dense v-for="(award, i) in person.awards" :key="i">
                <v-col cols="9" v-html="$sanitize(award.name)"></v-col>
                <v-col cols="3"> {{ award.year }}</v-col>
              </v-row>
            </ul>
          </div>
          <div v-if="person.projects">
            <h3>Projects:</h3>
            <ul>
              <li v-for="(proj, i) in person.projects" :key="i">{{ proj }}</li>
            </ul>
          </div>
        </v-col>
      </v-row>
      <i class="mdi mdi-open-in-new" @click="goToDesc" />
      <i class="mdi mdi-close people-dialog-close" @click="dialog = false" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    person: Object,
    title: String,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    goToDesc() {
      this.$router.push({
        name: "PeopleDetail",
        query: {
          id: this.person.id,
        },
      });
    },
    readName(){
      var audio = new Audio(this.person.audio)
      audio.play()
    }
  },
};
</script>

<style scoped lang="scss">
.people-image {
  max-width: 100%;
  width: 100%;
  max-height: 173.5px;
  height: 173.5px;
}

.people-card {
  cursor: pointer;
  transition: transform 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  padding-bottom: 10px;
}

.people i {
  font-size: 25px;
}

.people-dialog-card {
  padding: 20px;

  h4 {
    color: gray;
  }

  p {
    margin-top: 20px;
  }
}

.people-dialog-image {
  width: 100%;
  margin-top: 10px;
}

.people-dialog-close {
  color: rgb(153, 27, 30);
  font-size: 30px;
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}

.mdi-open-in-new {
  color: lightskyblue;
  font-size: 25px;
  position: absolute;
  right: 45px;
  top: 9px;
  cursor: pointer;
}

.working-with-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.775rem;
  font-weight: 400;
}

.person-modal-title {
  text-transform: uppercase;
}
/**
 * following are responsive support
 */
@media (max-width: 420px) {
  * {
    -webkit-overflow-scrolling: touch;
  }
  .people-image {
    max-height: 160px !important;
    height: 160px !important;
  }

  .people-dialog-image {
    width: 60%;
    margin-top: 40px;
  }

  .person-modal-name,
  .person-modal-title {
    text-align: center;
  }

  .mdi-open-in-new {
    width: 28px;
    font-size: 28px;
    top: 6px;
    right: 0px;
    left: 60px;
  }

  .people-dialog-close {
    width: 40px;
    font-size: 40px;
    top: 0px;
    right: 0;
    left: 10px;
  }
}
</style>
